import { render, staticRenderFns } from "./sendCourse.vue?vue&type=template&id=1d795322&scoped=true&"
import script from "./sendCourse.vue?vue&type=script&lang=js&"
export * from "./sendCourse.vue?vue&type=script&lang=js&"
import style0 from "./sendCourse.vue?vue&type=style&index=0&id=1d795322&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d795322",
  null
  
)

export default component.exports